import { useEffect } from 'react';
import { apiUrlPrefix } from '../../../config';
import { useNavigate } from 'react-router-dom';

const useAutoLogin = (isLoggedIn, setIsLoggedIn, attempts, setAttempts, setIsReady) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (attempts >= 3 || isLoggedIn === true) {
      // Stop execution if attempts >= 3 or if already logged in
      return;
    }

    const checkAuth = async () => {
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const refreshTokenExpiry = localStorage.getItem('refreshTokenExpiry');

        const response = await fetch(apiUrlPrefix + "MongoDb/CheckAuth", {
          method: "POST",
          credentials: "include", // Include cookies in the request
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            Token: refreshToken,
            Expirydate: refreshTokenExpiry
          }),
        });

        const responseInformation = await response.json();
        if (response.ok) {
          navigate('/discussions');
          setIsLoggedIn(true); // Set as logged in
        } else {
          if (responseInformation === 403) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('profilePicture');
            localStorage.removeItem('roles');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('refreshTokenExpiry');
            localStorage.removeItem('userId');
            localStorage.removeItem('username');
            navigate('/');
          }
        }
      } catch (error) {
        console.error("Failed to check authentication:", error);
      } finally {
        // 2. THIS IS THE KEY: Always set ready, regardless of success or failure
        setIsReady(true);
        setAttempts(prev => prev + 1);
      }
    };

    checkAuth(); // Run the authentication check
  }, [attempts, isLoggedIn, setIsLoggedIn, setAttempts]); // Depend on attempts and isLoggedIn
};

export default useAutoLogin;
